/** Escaped punctuation hides in this private-use block while markup is stripped. */
const HIDDEN_BASE = 0xe000;

export function markdownToPlainText(value: string | null | undefined): string {
  if (!value) return "";

  return (
    value
      // CommonMark: a backslash escapes any ASCII punctuation, which is then
      // text, never markup.
      .replace(/\\([!-/:-@[-`{-~])/g, (_, character: string) =>
        String.fromCharCode(HIDDEN_BASE + character.charCodeAt(0)),
      )
      .replace(/```[\s\S]*?```/g, (match) =>
        match.replace(/^```[^\n]*\n?/, "").replace(/\n?```$/, ""),
      )
      .replace(/`([^`]+)`/g, "$1")
      .replace(/!\[([^\]]*)\]\((?:[^()]|\([^()]*\))+\)/g, "$1")
      .replace(/\[([^\]]+)\]\((?:[^()]|\([^()]*\))+\)/g, "$1")
      .replace(/^#{1,6}\s+/gm, "")
      .replace(/^[\s>]*[-*+]\s+/gm, "")
      .replace(/^[\s>]*\d+\.\s+/gm, "")
      .replace(/^>\s?/gm, "")
      .replace(/(\*\*|__)(.*?)\1/g, "$2")
      .replace(/(\*|_)(.*?)\1/g, "$2")
      .replace(/~~(.*?)~~/g, "$1")
      .replace(/[\ue021-\ue07e]/g, (hidden) =>
        String.fromCharCode(hidden.charCodeAt(0) - HIDDEN_BASE),
      )
      .replace(/[ \t]+/g, " ")
      .replace(/\n{3,}/g, "\n\n")
      .trim()
  );
}
